// extracted by mini-css-extract-plugin
module.exports = {"legalContainer":"legal_legalContainer__igoUS","legalLinksContainer":"legal_legalLinksContainer__jU5A2","legalLink":"legal_legalLink__QOpkO","copyright":"legal_copyright__svOkI"};